import api from "./Api";

class RestricaoService {
  GetRestricao(payload) {
    return api.get("/v1/restricao/" + payload).then((response) => {
      return response.data;
    });
  }

  PostRestricao(payload) {
    return api.post("/v1/restricao/", payload).then((response) => {
      return response.data;
    });
  }

  PutRestricao(payload) {
    return api.put("/v1/restricao/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteRestricao(payload) {
    return api.delete("/v1/restricao/" + payload).then((response) => {
      return response.data;
    });
  }

  GetRestricaoOData(payload) {
    return api.get("/OData/Restricao" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new RestricaoService();
